import { createClient } from '@sanity/client'

export const client = createClient({
  projectId: 'dqt1f1qd',
  dataset: 'production',
  useCdn: true,
  apiVersion: '2024-01-01',
})

export default client
